<template>

    <div class="flex flex-col flex-1 ml-4 tech-progress-container">

            <span v-if="current_freshness>50" class="text-sm font-medium text-success leading-tighter mb-1_5">Актуально</span>
            <span v-else class="underline hover:cursor-pointer" @click="refresh">Обновить позицию</span>
            <div class="flex overflow-hidden w-full bg-gray-100 rounded h-0_5 tech-progress">
                <div :style="'width:'+current_freshness+'%'" :class="cls"></div>
            </div>
    </div>
</template>

<script>
export default {
    name: "RefreshItem",
    props: {
        freshness: {
            //type: Number,
            required: true
        },
        id: {
           required: true
        },
    },
    data () {
      return {
         current_freshness: this.freshness
      }
    },
    computed: {
      cls() {
          // let styles = ['bg-red-400','bg-yellow-400','bg-green-400'];
          switch (true){

              case (this.current_freshness<30): return 'bg-red-400';
              case (this.current_freshness<50): return 'bg-yellow-400';
          }

          return 'bg-green-400';
      }
    },
    methods: {
        refresh () {
            axios.get('/api/machinery-item/touch/'+this.id).then(()=>{
                this.current_freshness = 100;
            })

        }
    }

}
</script>

<style scoped>

</style>
